import React from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { Tooltip } from "@mui/material";

import { Close, Edit } from "@mui/icons-material";

//Styles
import { withStyles } from "tss-react/mui";
import Button from "../../../../../components/CustomButtons/Button";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";
import Table from "../../../../../components/Table/Table";
import OverzichtStyle from "./OverzichtStyle";

function Overzicht({ ...props }) {
  const { classes } = props;

  const convertTableData = () => {
    let output = [];

    if (!(props.customFields === null || props.customFields === "")) {
      try {
        const customFields = JSON.parse(props.customFields);

        output = customFields.map((prop) => {
          const simpleButtons = [
            {
              color: "success",
              icon: Edit,
              tooltip: <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.button.aanpassen"} />,
              click: () => props.onEdit(prop, "customButton"),
            },
            {
              color: "danger",
              icon: Close,
              tooltip: <TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />,
              click: () => props.onDelete(prop, "customButton", "DELETE"),
            },
          ].map((buttonProp, key) => {
            return (
              <Tooltip classes={{ tooltip: classes.tooltip }} key={key} placement={"bottom"} title={buttonProp.tooltip}>
                <Button
                  className={classes.actionButton}
                  color={buttonProp.color}
                  disabled={props.disableAll}
                  justIcon
                  onClick={buttonProp.click}
                  simple
                >
                  <buttonProp.icon className={classes.icon} />
                </Button>
              </Tooltip>
            );
          });

          return [
            prop.categorie,
            prop.name,
            prop.type,
            convertMenukaart(prop.menukaartid, prop.menukaartName),
            simpleButtons,
          ];
        });
      } catch (e) {}
    }

    return output;
  };

  const convertMenukaart = (menukaartid, menukaartName) => {
    if (menukaartName) {
      return menukaartName;
    }

    let output = props.menukaarten?.filter((x) => {
      return x.value === menukaartid;
    });

    if (output?.length > 0) {
      return output[0].label;
    }

    return "Menu kaarten niet gevonden";
  };

  return (
    <GridContainer>
      <GridItem lg={12} md={12} xs={12}>
        <Table
          customCellClasses={[classes.right]}
          customClassesForCells={[4]}
          customHeadCellClasses={[classes.right]}
          customHeadClassesForCells={[4]}
          tableData={convertTableData()}
          tableHead={[
            <TranslationWrapper
              tDefault={"Categorie"}
              tKey={"vestigingen.form.custombuttons.overzicht.table.head.categorie"}
            />,
            <TranslationWrapper tDefault={"Naam"} tKey={"vestigingen.form.custombuttons.overzicht.table.head.naam"} />,
            <TranslationWrapper tDefault={"Type"} tKey={"vestigingen.form.custombuttons.overzicht.table.head.type"} />,
            <TranslationWrapper
              tDefault={"Menukaart"}
              tKey={"vestigingen.form.custombuttons.overzicht.table.head.menukaart"}
            />,
            <TranslationWrapper
              tDefault={"actions"}
              tKey={"vestigingen.form.custombuttons.overzicht.table.head.actions"}
            />,
          ]}
        />
      </GridItem>
    </GridContainer>
  );
}

export default withStyles(Overzicht, OverzichtStyle);
